export default {
  parameters: {
    landing_id: "IDdes",
  },
  downtimeUrl: "https://id2.kodland.tech",
  startPage: {
    image: {
      url: "/welcome/quiz_indo_graphic_design_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_indo_graphic_design_mobile.png",
      style: {
        width: "100%",
      },
    },
    title: "Kami mengajak anak usia 8-17 tahun untuk mengikuti kelas online desain grafis",
    subtitle:
      "Anak-anak akan mencoba kreativitas digital mereka: kartun, animasi, ilustrasi, pemodelan, 3D, desain",
    button: "Mulai  🚀",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Terima kasih karena sudah mempercayakan kami sebagai platform edukasi Anda! Sayangnya, tablet atau handphone tidak dapat digunakan untuk mengikuti pembelajaran kami. Dengan senang hati kami akan menantikan kehadiran Anda kembali di kelas!",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran 🚀 GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
        "🏛️ Ilmu budaya (Sejarah, Literasi, dsb.)",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    2: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "♟️ Bermain permainan papan",
        "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
      ],
    },
    3: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    4: {
      question: "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true
        },
      ],
    },
  },
};
